<template>
    <!-- 奖惩管理 -->
    <div>
        <div v-show="Jcgl">
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">工资申请单</div>
            <!-- 主体 -->
            <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
                <!-- 查询框 -->
                <div style="margin-left:3%">
                    <div style="height:10px"></div>
                    <div style="display:inline-block">
                        <span>组织架构</span>
                        <el-cascader v-model="condition.organize_ids" clearable
                            style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
                    </div>

                    <div style="display:inline-block;margin-left:20px">
                        <span>城市 </span>
                        <el-select v-model="condition.city_id" style="margin-left:10px;width:150px"
                            :placeholder="postPlaceholder" clearable>
                            <el-option v-for="item in cityList" :key="item.id" :label="item.post_name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>

                    <div style="display:inline-block;margin-left:20px">
                        <span>处罚日期 </span>
                        <el-date-picker style="width:150px;margin-left:10px" v-model="condition.current_date"
                            type="date" placeholder="请选择" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>

                    <div style="display:inline-block;">
                        <span>岗位 </span>
                        <el-select v-model="condition.post_id" style="margin-left:10px;width:150px" placeholder="请选择"
                            clearable>
                            <el-option v-for="item in postList" :key="item.id" :label="item.post_name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>

                    <div style="display:inline-block;margin-left:15px;">
                        <span>姓名 </span>
                        <el-input v-model="condition.staff_name" style="margin-left:10px;width:150px"
                            placeholder="请输入姓名"></el-input>
                    </div>

                    <div style="display:inline-block;margin-left:20px">
                        <span>状态 </span>
                        <el-select v-model="condition.reviewer_state" style="margin-left:10px;width:150px"
                            placeholder="请选择" clearable>
                            <el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>

                    <div style="display:inline-block;margin-left:20px; margin-top: 20px;">
                        <span>类别 </span>
                        <el-select v-model="condition.dictionaries_id" style="margin-left:10px;width:150px"
                            placeholder="请选择" clearable>
                            <el-option v-for="item in dictionariesList" :key="item.id" :label="item.data"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>

                    <!-- 按钮 -->
                    <div style="display:inline-block;margin-left:50px">
                        <el-button type="goon" @click="Find">查询</el-button>
                        <el-button type="goon" @click="Del(null)">删除</el-button>
                        <el-button type="addbtn" @click="add">新增</el-button>
                    </div>
                </div>

                <!-- 表格 -->
                <div style="margin:2% 3% 0 3%">
                    <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%;" height="540" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column align="center" label="序号" width="50">
                            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                        </el-table-column>
                        <el-table-column prop="organize_name" align="center" label="组织架构" width="300"></el-table-column>
                        <el-table-column prop="city_id" align="center" label="城市"></el-table-column>
                        <el-table-column prop="post_name" align="center" label="职位"></el-table-column>
                        <el-table-column prop="staff_name" align="center" label="姓名" width="120"></el-table-column>
                        <el-table-column prop="dictionaries_data" align="center" label="类别"></el-table-column>
                        <el-table-column prop="current_date" align="center" label="时间"></el-table-column>
                        <el-table-column prop="reason" align="center" label="原因" width="180"></el-table-column>
                        <el-table-column prop="money" align="center" label="金额"></el-table-column>
                        <el-table-column align="center" label="状态" width=100>
                            <template slot-scope="scope">
                                <img src="../../../assets/待审批.png" v-show="scope.row.reviewer_state === '0'" />
                                <img src="../../../assets/已同意.png" v-show="scope.row.reviewer_state === '1'" />
                                <img src="../../../assets/stateImg/状态_已驳回.png"
                                    v-show="scope.row.reviewer_state === '2'" />
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="150">
                            <template slot-scope="scope">
                                <img src="../../../assets/编辑.png" @click="Edit(scope.row)">
                                <img src="../../../assets/删除.png" @click="Del(scope.row.id)">
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <el-row style="margin-top: 10px; text-align: center;">
                        <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                            layout=" prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </el-row>
                </div>

            </div>
        </div>
        <add ref="adds" v-show="showadd"></add>
    </div>
</template>

<script>
    import add from './Jcgl_add.vue';
    import axios from 'axios';
    export default {
        components: {
            add: add,
        },
        data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //条件
                condition: {
                    organize_ids: [],
                    city_id: '',
                    current_date: '',
                    post_id: '',
                    staff_name: '',
                    reviewer_state: '',
                    dictionaries_id: '',
                },

                //详情
                ruleForm: {
                    id: '',
                    dictionaries_id: '',
                    staff_id: '',
                    project_id: '',
                    project_name: '',
                    post_id: '',
                    post_name: '',
                    current_date: '',
                    reason: '',
                    money: '',
                    examineDetailsList: [],
                },

                // 权限
                Jcgl: true,
                showedit: false,

                //删除ids
                ids: [],

                //状态数据
                ztList: [{
                    value: '0',
                    label: '待审批'
                }, {
                    value: '1',
                    label: '已同意'
                }, {
                    value: '2',
                    label: '已驳回'
                }],
                //职位数据
                postList: [],
                //类别数据
                dictionariesList: [],

                //级联下拉配置
                props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
                    value: "id",
                    label: "organize_name",
                    children: "organizeList",
                    checkStrictly: true,
                    multiple: true,
                },

                //组织架构数据
                organizeList: [],
            };
        },
        methods: {
            // 全选
            handleSelectionChange(e) {
                this.ids = [];
                e.forEach((item) => {
                    this.ids.push(item.id);
                });
            },
            // 新增
            add() {
                this.Jcgl = false;
                this.showadd = true;
                this.trash();
            },
            // 返回
            Return() {
                this.showadd = false;
                this.Jcgl = true;
                this.trash();
                this.Find();
            },
            // 操作删除
            async Del(e) {
                var ids;
                if (e === null || e === "" || e === undefined) {
                    if (this.ids === null || this.ids.length <= 0) {
                        this.$message.warning("请先选择操作数据！");
                        return false;
                    }
                    ids = this.ids;
                } else {
                    ids = [e];
                }

                var url = "bonusPenalty/del";
                var record = {
                    ids: ids,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.trash();
                        this.Find();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            // 操作详情
            Edit(e) {
                this.Jcgl = false;
                this.showadd = true;
                this.ruleForm.id = e.id;
                this.ruleForm.dictionaries_id = e.dictionaries_id;
                this.ruleForm.staff_id = e.staff_id;
                this.ruleForm.project_id = e.project_id;
                this.ruleForm.project_name = e.organize_name;
                this.ruleForm.post_id = e.post_id;
                this.ruleForm.post_name = e.post_name;
                this.ruleForm.current_date = e.current_date;
                this.ruleForm.reason = e.reason;
                this.ruleForm.money = e.money;
            },
            //查询
            async Find() {
                var temporary = [];
                this.condition.organize_ids.forEach(item => {
                    temporary.push(item[item.length - 1]);
                })
                var organize_ids = "";
                temporary.forEach(item => {
                    organize_ids += item + ",";
                })
                
                var url = 'bonusPenalty/find';
                var record = {
                    page_num: this.page_num,
                    page_size: this.page_size,
                    organize_ids: organize_ids,
                    city_id: this.condition.city_id,
                    current_date: this.condition.current_date,
                    post_id: this.condition.post_id,
                    staff_name: this.condition.staff_name,
                    reviewer_state: this.condition.reviewer_state,
                    dictionaries_id: this.condition.dictionaries_id,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.warning('请求失败！请稍后重试');
                    }
                }
            },
            //分页
            handleCurrentChange(val) {
                this.page_num = val;
                this.Find();
            },
            //清除数据
            trash() {
                this.ruleForm.id = '';
                this.ruleForm.dictionaries_id = '';
                this.ruleForm.staff_id = '';
                this.ruleForm.staff_name = '';
                this.ruleForm.project_id = '';
                this.ruleForm.project_name = '';
                this.ruleForm.post_id = '';
                this.ruleForm.post_name = '';
                this.ruleForm.current_date = '';
                this.ruleForm.reason = '';
                this.ruleForm.money = '';
                this.ruleForm.examineDetailsList = [];
            },
            //初始化组织架构及下面的人
            async organizeFind() {
                var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                    identification: "1",
                    id: this.condition.project_id
                });
                this.organizeList = this.getTreeData(organizeList.data);

            },
            getTreeData(data) {
                // 循环遍历json数据
                for (var i = 0; i < data.length; i++) {

                    if (data[i].organizeList.length < 1) {
                        // children若为空数组，则将children设为undefined
                        data[i].organizeList = undefined;
                    } else {
                        // children若不为空数组，则继续 递归调用 本方法
                        this.getTreeData(data[i].organizeList);
                    }
                }
                return data;
            }
        },
        async created() {
            this.Find();
            this.organizeFind();
            // 职位
            var postList = await this.$globals.AxiosPost("post/selectFind", {});
            this.postList = postList.data;
            // 类别
            var dictionariesList = await this.$globals.AxiosPost("dictionaries/selectFind", {
                data_grouping: "bonus_penalty"
            });
            this.dictionariesList = dictionariesList.data;
        },
    };
</script>

<style>
    .el-button--goon:focus,
    .el-button--goon:hover {
        background: #006e4b;
        border-color: #05573d;
        color: #fff;
    }

    .el-button--addbtn:focus,
    .el-button--addbtn:hover {
        background: #fff;
        border-color: #05573d;
        color: #006e4b;
    }

    .el-button--goon {
        color: #fff;
        background-color: #006e4b;
        border-color: #006e4b;
        font-size: 15px;
        width: 85px;
    }

    .el-button--addbtn {
        color: #006e4b;
        background-color: #fff;
        border-color: #006e4b;
        font-size: 15px;
        width: 85px;
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #006e4b;
        border-color: #006e4b;
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #006e4b;
    }

    .el-checkbox__inner:hover {
        border-color: #006e4b;
    }
</style>



// WEBPACK FOOTER //
// Jcgl.vue?746b3edc